export const FETCH_QUEUE_JOBS = 'FETCH_QUEUE_JOBS';
export const ADD_JOB_TO_QUEUE = 'ADD_JOB_TO_QUEUE';
